<template>
  <div class="instrument-detail-container">
    <!-- 加载状态 -->
    <el-loading v-if="loading" fullscreen text="正在加载加载仪器加载仪器详情..."></el-loading>

    <!-- 错误提示 -->
    <el-alert
      v-if="error"
      title="数据加载失败"
      :description="error"
      type="error"
      show-icon
      class="error-alert"></el-alert>

    <!-- 未找到对应仪器时显示 -->
    <el-empty
      v-if="!loading && !error && !instrument"
      description="未找到对应仪器信息"
      class="empty-state"></el-empty>

    <div v-if="instrument && !loading && !error">
      <!-- 上部信息区域 -->
      <div class="upper-section">
        <!-- 左侧：图片轮播和基本信息 -->
        <div class="left-panel">
          <!-- 图片轮播 -->
          <div class="image-carousel">
            <el-carousel height="350px" indicator-position="bottom">
              <el-carousel-item v-for="(img, index) in instrument.allImageUrls" :key="index">
              <el-image
                :src="img"
                :alt="`${instrument.instrumentName} 图片 ${index + 1}`"
                fit="contain"
                class="carousel-image">
                <template #error>
                  <div class="image-placeholder">
                    <el-icon class="placeholder-icon">
                      <Picture />
                    </el-icon>
                    <span>无图片</span>
                  </div>
                </template>
              </el-image>
              </el-carousel-item>
            </el-carousel>
          </div>

          <!-- 基本信息 -->
          <div class="basic-info">
            <h1 class="instrument-name">{{ instrument.instrumentName }}</h1>

            <div class="info-grid">
              <div class="info-item">
                <span class="info-label">仪器平台：</span>
                <span class="info-value">{{ instrument.platform }}</span>
              </div>

              <div class="info-item">
                <span class="info-label">仪器型号：</span>
                <span class="info-value">{{ instrument.model }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">仪器数量：</span>
                <span class="info-value">{{ instrument.quantity }}</span>
              </div>

              <div class="info-item">
                <span class="info-label">参考价格：</span>
                <span class="info-value">{{ instrument.price }}</span>
              </div>


            </div>
            <div class="basic-info">
              <span class="info-label">应用范围：</span>
              <span class="info-value" v-html="handledApplicationScope"></span>
            </div>
          </div>
        </div>

        <!-- 右侧：联系人信息 -->
        <div class="right-panel">
          <div class="contact-card">
            <h3 class="contact-title">联系方式</h3>

            <div class="contact-info">
              <div class="contact-item">
                <el-icon class="contact-icon">
                  <User />
                </el-icon>
                <span class="contact-label">联系人：</span>
                <span class="contact-value">{{ instrument.contactPerson }}</span>
              </div>

              <div class="contact-item">
                <el-icon class="contact-icon">
                  <Phone />
                </el-icon>
                <span class="contact-label">联系方式</span>
                <span class="contact-value">{{ instrument.contactInfo }}</span>
              </div>

            </div>

          </div>
        </div>
      </div>

      <!-- 下部详细信息区域 -->

    </div>
  </div>
</template>

<script>
import { User, Phone, Message, Picture, DataAnalysis, Tools, Service } from '@element-plus/icons-vue';
import { formatTextWithLineBreak, sliceImgUrlRow } from '@/utils/MyUtils';

export default {
  name: 'InstrumentDetail',
  components: {
    User,
    Phone,
    Message,
    Picture,
    DataAnalysis,
    Tools,
    Service
  },
  data() {
    return {
      instrument: null,
      loading: true,
      error: null,
      id: this.$route.params.id // 从路由参数获取仪器ID
    };
  },
  mounted() {
    this.loadInstrumentData();
  },
  computed: {
    handledApplicationScope() {
      return formatTextWithLineBreak(this.instrument.applicationScope)
    }
  },
  methods: {
    // 加载所有仪器数据并筛选
    async loadInstrumentData() {
      try {
        this.loading = true;
        // 使用axios从JSON文件加载数据
        let url = `/instrument/${this.id}`
        const response = await this.$http.get(url); // 假设JSON文件路径
        this.instrument = response.data;
        sliceImgUrlRow(this.instrument);//切割并生成图片列表

      } catch (err) {
        this.error = '数据加载失败，请稍后重试';
        console.error('加载仪器数据出错:', err);
      } finally {
        this.loading = false;
      }
    },
  }
};
</script>

<style scoped>
.basic-info {
  margin-top: 2%;
}

/* 样式与之前保持一致 */
.instrument-detail-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 30px;
}

.error-alert {
  margin-bottom: 20px;
}

.empty-state {
  padding: 60px 0;
}

/* 上部区域样式 */
.upper-section {
  display: flex;
  gap: 30px;
  margin-bottom: 40px;
  flex-wrap: wrap;
}

.left-panel {
  flex: 3;
  min-width: 600px;
}

.right-panel {
  flex: 1;
  min-width: 300px;
}

/* 图片轮播样式 */
.image-carousel {
  width: 100%;
  margin-bottom: 30px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.carousel-image {
  width: 100%;
  height: 100%;
  background-color: #f9f9f9;
}

.image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  color: #999;
  gap: 15px;
}

.placeholder-icon {
  font-size: 48px;
}

/* 基本信息样式 */
.instrument-name {
  font-size: 28px;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eaeaea;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.info-item {
  display: flex;
  flex-wrap: wrap;
}

.info-label {
  font-weight: 500;
  color: #666;
  margin-right: 8px;
  min-width: 100px;
}

.info-value {
  color: #333;
  flex: 1;
}

/* 联系人卡片样式 */
.contact-card {
  background-color: #f8fafc;
  border-radius: 8px;
  padding: 25px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  height: 100%;
  border: 1px solid #e2e8f0;
}

.contact-title {
  font-size: 20px;
  color: #2c3e50;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e2e8f0;
}

.contact-info {
  margin-bottom: 30px;
}

.contact-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 10px 0;
  border-bottom: 1px dashed #e2e8f0;
}

.contact-item:last-child {
  border-bottom: none;
}

.contact-icon {
  color: #42b983;
  margin-right: 15px;
  font-size: 20px;
  width: 24px;
  text-align: center;
}

.contact-label {
  color: #666;
  min-width: 80px;
}

.contact-value {
  color: #333;
  flex: 1;
}

.email-link {
  color: #42b983;
  text-decoration: none;
  transition: color 0.2s;
}

.email-link:hover {
  color: #359e6f;
  text-decoration: underline;
}




/* 下部区域样式 */
.lower-section {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.detail-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 25px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #eaeaea;
  transition: transform 0.2s, box-shadow 0.2s;
}

.detail-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}

.detail-title {
  font-size: 18px;
  color: #2c3e50;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
}

.detail-icon {
  margin-right: 10px;
  color: #42b983;
}

.detail-content {
  color: #4a5568;
  line-height: 1.8;
  font-size: 15px;
  padding-left: 34px;
}

/* 价格样式 */
.price-section {
  margin-top: 30px;
  padding-top: 20px;
  display: flex;
  align-items: center;
}

.price-label {
  font-weight: 600;
  color: #666;
  margin-right: 10px;
  min-width: 80px;
}

.price-value {
  font-size: 20px;
  /* 增大字体 */
  font-weight: bold;
  color: #e53e3e;
  /* 红色 */
  flex: 1;
}

/* 响应式调整 */
@media (max-width: 1024px) {
  .upper-section {
    flex-direction: column;
  }

  .left-panel,
  .right-panel {
    min-width: 100%;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .instrument-detail-container {
    padding: 15px;
  }

  .instrument-name {
    font-size: 24px;
  }

  .image-carousel {
    height: 250px;
  }

  .detail-content {
    padding-left: 0;
  }
}
</style>
